<template>
    <FixedHeader
        v-if="mounted"
        headerClass="DefaultHeader"
        fixedClass="is-fixed"
        :threshold="100"
    >
        <div>
            <slot>
            </slot>
            <div @click="closeSearch" class="DefaultHeader__overlay" />
            <header>
                <div class="DefaultHeader__container">
                    <div class="container flex-center-b">
                        <HeaderLogo
                            width="99"
                            height="64"
                            classes="header-is-static"
                        />
                        <DefaultNav
                            :nav="nav"
                            :do-see="doSee"
                            :subnav="destinations"
                            :nav-is-active="navIsActive"
                        />
                        <HeaderSearch :class="{'HeaderSearch--hidden-notification' : notificationHidden}" />
                        <HeaderMobileNav
                            @toggle="toggleNav"
                        />
                    </div>
                </div>
                <nav-flyout :style-class="flyoutType === 'Destinations' ? 'NavFlyout' : 'NavFlyout NavFlyout--do-see'">
                    <div
                        v-if="flyoutType === 'Destinations'"
                        class="container"
                    >
                        <ul class="grid">
                            <li
                                v-for="item in destinations"
                                :key="item.id"
                                class="grid__item one-fifth"
                            >
                                <BaseImage
                                    :placeholder="item.placeholder"
                                    :srcset="item.image"
                                    :ratio="item.ratio"
                                />

                                <BaseHeading
                                    :heading="item.heading"
                                    tag="h5"
                                    class="mb-base mt-small h7"
                                />

                                <ul
                                    class="NavFlyout__list"
                                    v-if="item.children.length">
                                    <li
                                        v-for="child in item.children.slice(0,3)"
                                        :key="child.id"
                                        class="mb-small"
                                    >
                                        <a
                                            :href="child.url"
                                            class="link"
                                        >
                                            {{ child.title }}
                                        </a>
                                    </li>
                                </ul>
                                <BaseButton
                                    :href="item.url"
                                    modifier="small"
                                >
                                    Discover more
                                </BaseButton>
                            </li>
                        </ul>
                    </div>
                    <div v-if="flyoutType === 'Do & See'" class="container">
                        <ul class="grid NavFlyout__flex">
                            <li
                                v-for="item in doSeeSections"
                                :key="item.id"
                                class="grid__item one-quarter NavFlyout__border"
                            >
                                <div class="NavFlyout__spacing NavFlyout__flex">
                                    <div class="pr-small">
                                        <base-icon :icon="item.classes" class="NavFlyout__icon" />
                                    </div>
                                    <div>
                                        <a :href="item.url">
                                            <base-heading
                                                :heading="item.title"
                                                tag="h5"
                                                class="mb-base h7"
                                            />
                                        </a>
                                        <ul class="NavFlyout__list">
                                            <li
                                                v-for="child in item.children"
                                                :key="child.id"
                                                class="mb-base"
                                            >
                                                <a :href="child.url" class="link">
                                                    {{ child.title }}
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </li>
                            <li class="grid__item one-quarter">
                                <ul class="NavFlyout__spacing">
                                    <li
                                        v-for="item in doSeeLinks"
                                        :key="item.id"
                                        class="mb-base"
                                    >
                                        <a :href="item.url" class="flex-center">
                                            <base-icon :icon="item.classes" class="NavFlyout__icon mr-small" />
                                            <BaseHeading
                                                :heading="item.title"
                                                tag="h5"
                                                class="h7"
                                            />
                                        </a>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </nav-flyout>
            </header>
        </div>
    </FixedHeader>
</template>
<script>
import FixedHeader from 'vue-fixed-header'
import { EventBus } from '../scripts/event-bus'

export default {
    name: 'DefaultHeader',
    components: {
        FixedHeader,
    },
    props: {
        nav: {
            type: Array,
            default: null,
        },
        destinations: {
            type: Array,
            default: null,
        },
        doSee: {
            type: Array,
            default: null
        }
    },
    data() {
        return {
            navIsActive: false,
            flyoutType: null,
            doSeeSections: [],
            doSeeLinks: [],
            object: null,
            mounted: false,
            notificationHidden: true,
        }
    },
    mounted() {
        this.mounted = true;

        EventBus.$on('flyoutType', (type) => {
            this.$data.flyoutType = type
        })

        EventBus.$on('notification', (hidden) => {
            this.$data.notificationHidden = hidden
        })

        this.$props.doSee.forEach((item) => {
            if (item.children.length) {
                this.$data.doSeeSections.push(item)
            } else {
                this.$data.doSeeLinks.push(item)
            }
        })
    },
    methods: {
        toggleNav(isActive) {
            this.navIsActive = isActive
        },
        closeSearch() {
            document.querySelector('body').classList.remove('has-overlay');
        }
    }
}
</script>

<style lang="scss">
    @keyframes fadeIn {
        0% {
            opacity: 0;
            transform: translateY(-74px);
        }
        100% {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .DefaultHeader {
        position: relative;
        width: 100vw;
        border-bottom: 1px solid $border-color;
        z-index: 20;

        &.is-fixed {
            position: fixed;
            top: 0;
            opacity: 0;
            animation: fadeIn 0.3s ease-out forwards;
        }

        header {
            position: relative;
        }
    }

    .DefaultHeader__container {
        position: relative;
        background: getColor('white');
        z-index: 3;

        @include media-query(reciteme-and-up) {
            padding: getSpacing('base') 0;
        }

        > .container {
            position: relative;

            @include media-query(palm) {
                padding-right: 0;
            }
            @include media-query(reciteme) {
                flex-wrap: wrap;
                .DefaultNav {
                    width: 100%;
                    margin-left: -1.5rem;
                    order: 2;
                }
            }
        }
    }

    .HeaderLogo svg {
        fill: getColor('black');
    }

    .DefaultHeader__overlay {
        display: none;
        position: fixed;
        left: 0;
        right: 0;
        width: 100vw;
        height: 100vh;

        body.has-overlay & {
            display: block;
        }
    }

    .pr-small {
        padding-right: .5rem!important;

        svg {
            margin-top: -5px;
        }
    }

    .mr-small {
        margin-right: .5rem!important;
    }
</style>

